var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_2777_3289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4749 10.4836C8.55027 12.8314 3.84067 19.0922 4.6256 29.2661C5.41054 39.44 23.464 64.4835 39.1627 59.7878C51.7216 55.8748 58.786 43.3531 56.4312 26.9183C54.0764 10.4836 49.3668 7.35313 44.6572 8.13574C39.9476 8.91835 34.4531 9.70094 29.7435 9.70094C25.0339 9.70094 19.5394 5.78791 12.4749 10.4836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5263 10.5694L12.5263 10.5695L12.5303 10.5668C16.0375 8.23561 19.1512 8.04162 21.9786 8.43045C23.148 8.59126 24.2669 8.85149 25.3477 9.10287C25.5767 9.15612 25.8039 9.20898 26.0296 9.2604C27.3175 9.5539 28.5537 9.80094 29.7435 9.80094C34.462 9.80094 39.9637 9.01705 44.6736 8.23439C45.8375 8.04098 46.9962 8.09008 48.1166 8.52251C49.2369 8.95487 50.3264 9.77331 51.3474 11.1306C53.3922 13.849 55.1555 18.7195 56.3323 26.9325C58.6819 43.3313 51.6338 55.7972 39.1334 59.6922C35.2392 60.8568 31.1935 60.1793 27.2964 58.34C23.3987 56.5005 19.6555 53.5013 16.3741 50.0343C13.0931 46.5678 10.2772 42.6371 8.23306 38.9392C6.1875 35.2388 4.91992 31.7808 4.72531 29.2584C3.94314 19.1204 8.63583 12.8967 12.5263 10.5694Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3289",
    x: 0.539062,
    y: 0.0263672,
    width: 60.3438,
    height: 60.3418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3289"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3289",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth37);
export default __webpack_public_path__ + "static/media/teeth37.4819d9e275b2cc74098cbba3f5326ce6.svg";
export { ForwardRef as ReactComponent };